const ratio = (number) => number / (300 / 72)

export default ratio
